import { axiosInstance } from "api/axios";
import { useQuery } from "react-query";
import { IKycsResponse } from "./types";

export const INVESTOR_PROFILE_QUERY_KEY = "/investors/profile";

export const useGetProfile = () => {
	return useQuery<any>(["/profile"], async () => {
		const data = await axiosInstance.get(`/profile`);
		return data;
	});
};

export const useGetListPotential = () => {
	return useQuery<any>(["/user/investor/potentialList"], async () => {
		const data = await axiosInstance.get(`/user/investor/potentialList`);
		return data.data;
	});
};

export const useGetProfileInvestor = (reload?: number, options?: any) => {
	return useQuery<any>(
		[INVESTOR_PROFILE_QUERY_KEY, reload],
		async () => {
			const data = await axiosInstance.get(`/investors/profile`);
			return data;
		},
		options,
	);
};

export const useGetKycInvestor = (id: string, options?: any) => {
	return useQuery<IKycsResponse>(
		["/ctos/transactions"],
		async () => {
			const { data } = await axiosInstance.get(`/ctos/transactions/${id}`);
			return data;
		},
		options,
	);
};
